/**
 * Page d'accueil par rôle après connexion (B7, issue #42).
 *
 * patient → /appointments · praticien → /practitioner/dashboard ·
 * secrétaire → /secretary/center · admin → /admin.
 *
 * @module lib/roleHome
 */

import type { UserRole } from './types';

export function roleHomePath(role: UserRole | undefined | null): string {
  switch (role) {
    case 'PATIENT':
    case 'PATIENT_REPRESENTATIVE':
      return '/appointments';
    case 'PRACTITIONER_ACTIVE':
    case 'PRACTITIONER_PENDING':
      return '/practitioner/dashboard';
    case 'MEDICAL_SECRETARY':
      return '/secretary';
    case 'ADMIN':
    case 'SUPPORT':
    case 'COMPLIANCE':
      // `/admin` n'existe pas : la redirection post-login menait a une page inexistante, donc
      // SANS en-tete ni navigation — un admin ne pouvait plus rien atteindre apres connexion
      // (trouve par l'e2e de #68, pas par lecture du code).
      // Destination = le tableau de bord : c'est la vue d'ensemble attendue apres connexion,
      // pas la file de validation (qui suppose une action immediate).
      return '/admin/tableau-de-bord';
    default:
      return '/search';
  }
}
